import { isBrowser } from 'constants/browser';

export const getBrowserString = (defaultString?: string) => {
  if (isBrowser.SAFARI) return 'Safari';
  if (isBrowser.CHROME) return 'Chrome';
  if (isBrowser.FIREFOX) return 'Firefox';

  return defaultString;
};
